import {
  commitMutation,
  graphql
} from 'react-relay';
import environment from '../Environment';

const mutation = graphql`
mutation SendForSignatureStatusMutation($token: String!, $contractId: ID!) {
  sendForSignatureStatus(token: $token, contractId: $contractId) { 
    ok
    status
    statusError
    error
  }
}
`;

export default ({ propositionId, token }, done) => {
  const variables = {
    contractId: propositionId,
    token
  };

  commitMutation(
    environment,
    {
      mutation,
      variables,
      updater: () => {
      },
      optimisticUpdater: () => {
      },
      onCompleted: (response) => {
        const { ok, status, error, statusError } = response.sendForSignatureStatus;
        done(ok, { value: status, error: statusError }, error);
      },
      onError: err => console.error(err)
    }
  );
};
